import { render, staticRenderFns } from "./finished.vue?vue&type=template&id=874c922c&scoped=true"
import script from "./finished.vue?vue&type=script&lang=js"
export * from "./finished.vue?vue&type=script&lang=js"
import style0 from "./finished.vue?vue&type=style&index=0&id=874c922c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874c922c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('874c922c')) {
      api.createRecord('874c922c', component.options)
    } else {
      api.reload('874c922c', component.options)
    }
    module.hot.accept("./finished.vue?vue&type=template&id=874c922c&scoped=true", function () {
      api.rerender('874c922c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderAudit/finished.vue"
export default component.exports